import http, { AUTH_ROUTES } from "../../../services/api";

export const getDashboardData = async (commodity, setData, setError, estateId) => {
  try {
    const result = await http.get(AUTH_ROUTES.GET_DASHBOARD_DATA(commodity, estateId));
    const data = result?.data?.data;
    if (data) {
      setData(data);
    }
  } catch (e) {
    const msg =
      e?.response?.data?.data || e?.message || "Failed to fetch dashboard data";
    console.error(`[getDashboardData] ${commodity}:`, msg);
    if (setError) setError(msg);
  }
};
